module.exports = __webpack_public_path__ + "static/media/close-color.5bcd24ed.svg";